import moment from "moment";
import { TimelineInterval } from "../Api/StatsTimelineApi";
import { ValueChartDataProvider, ValueChartItem } from "../Components/PercentValueChart/ValueChart";

/**
 * Represents the popularity stats data that we receive from the server. This data will be 
 * shown on a graph on the analytics page
*/
export default class HourlyPopularityStats implements ValueChartDataProvider {
    public readonly data: ValueChartItem[];
    public readonly interval: TimelineInterval = "hour";
    public readonly from: string | null;
    public readonly to: string | null;

    constructor(
        data: number[] = [],
        from: string | null = null,
        to: string | null = null,
    ) {
        this.from = from;
        this.to = to;
        this.data = [];

        for (let i: number = 0; i < 24; i++) {
            const theDate = moment()
                .set(this.interval, i)
                .format("LT")
                .replace(/[:.e][0-9]{2}/, "");

            this.data.push({
                name: theDate,
                value: data?.[i] || 0,
                children: [],
            });
        }
    }

    public getRawData(): ValueChartItem[] {
        return this.data;
    }

    public getChartLabels(): string[] {
        return Object.values(this.getChartData()).map((item) => item.name);
    }

    getChartTotal(): number {
        return this.data.reduce((carry, item) => carry += item.value, 0);
    }

    public getChartData(): ValueChartItem[] {
        return this.data;
    }
}
